<section class="rn-page">
  <app-admin-page-header title="Release Notes">
    <p description>View platform updates and manage release documentation.</p>
    <ng-container actions>
      <app-admin-button variant="ghost" type="button" routerLink="/platform/settings">Back to settings</app-admin-button>
      @if (showCreate()) {
        <app-admin-button variant="accent" type="button" (click)="openCreate()" [disabled]="!canCreate()">
          Create release
        </app-admin-button>
      }
    </ng-container>
  </app-admin-page-header>

  @if (showManage()) {
    <app-admin-card title="Admin management" subtitle="Create, edit, and publish release notes" class="rn-page__section">
      <div class="rn-page__toolbar">
        <app-release-search [value]="adminSearch()" (valueChange)="onAdminSearchChange($event)" />
      </div>

      @if (adminLoading()) {
        <div class="rn-page__skeletons">
          <app-admin-skeleton variant="card" />
          <app-admin-skeleton variant="card" />
        </div>
      } @else if (adminError()) {
        <div class="cg-admin-alert cg-admin-alert--error">
          {{ adminError() }}
          <app-admin-button variant="ghost" type="button" (click)="loadAdmin()">Retry</app-admin-button>
        </div>
      } @else if (filteredAdminReleases().length === 0) {
        <app-admin-empty-state
          icon="file-text"
          title="No release notes yet"
          description="Create your first release to document platform updates."
        />
      } @else {
        <app-release-management-table
          [releases]="filteredAdminReleases()"
          [loading]="adminLoading()"
          [canEdit]="canEdit()"
          [canCreate]="canCreate()"
          [canPublish]="canPublish()"
          [showEdit]="showEdit()"
          [showCreate]="showCreate()"
          [showPublish]="showPublish()"
          (view)="viewReleaseInViewer($event)"
          (edit)="openEdit($event)"
          (duplicate)="duplicateRelease($event)"
          (publish)="publishRelease($event)"
          (unpublish)="unpublishRelease($event)"
          (remove)="removeRelease($event)"
        />
      }
    </app-admin-card>
  }

  <div id="release-notes-viewer">
  <app-admin-card
    title="Release notes"
    subtitle="Published releases, newest first"
    class="rn-page__section"
  >
    <div class="rn-page__toolbar">
      <app-release-search [value]="viewerSearch()" (valueChange)="onViewerSearchChange($event)" />
    </div>

    @if (viewerLoading()) {
      <div class="rn-page__skeletons">
        <app-admin-skeleton variant="card" />
        <app-admin-skeleton variant="card" />
      </div>
    } @else if (viewerError()) {
      <div class="cg-admin-alert cg-admin-alert--error">
        {{ viewerError() }}
        <app-admin-button variant="ghost" type="button" (click)="loadViewer()">Retry</app-admin-button>
      </div>
    } @else if (filteredPublishedReleases().length === 0) {
      <app-admin-empty-state
        icon="file-text"
        title="No published releases"
        description="Published release notes will appear here for all platform users."
      />
    } @else {
      <app-release-accordion
        [releases]="filteredPublishedReleases()"
        [expandedIds]="expandedViewerIds()"
        (expandedIdsChange)="onExpandedChange($event)"
      />
    }
  </app-admin-card>
  </div>

  @if (showForm()) {
    <app-admin-modal
      [title]="editingId() ? 'Edit release' : 'Create release'"
      size="2xl"
      (closed)="closeForm()"
    >
      <app-release-form
        [form]="form()"
        [saving]="saving()"
        [error]="formError()"
        (formChange)="form.set($event)"
        (save)="saveForm()"
        (cancel)="closeForm()"
      />
    </app-admin-modal>
  }
</section>
